<template>
    <on-click-outside :do="close">
        <div class="form-group-floating-label relative rounded" :class="{ 'is-active': isOpen }">
            <button
                ref="button"
                type="button"
                class="form-input text-left select-none appearance-none cursor-pointer relative"
                :class="{ 'pt-sm': value !== null}"
                @click="open"
            >
                <span v-if="value !== null" class="fake-placeholder has-value">
                    {{ placeholder }}
                </span>
                <span v-if="value !== null" class="block">{{ value }}</span>
                <span v-else class="fake-placeholder">
                    {{ placeholder }}
                </span>

                <div class="form-select-dropdown-arrow">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                    </svg>
                </div>
            </button>
            <div
                v-show="isOpen"
                ref="dropdown"
                class="my-sm absolute pin-l pin-r bg-white p-sm rounded shadow-dropdown z-50"
            >
                <input
                    ref="search"
                    v-model="search"
                    class="border block mb-md w-full p-sm bg-white text-neutral-darkest rounded"
                    @keydown.esc="close"
                    @keydown.up="highlightPrev"
                    @keydown.down="highlightNext"
                    @keydown.enter.prevent="selectHighlighted"
                    @keydown.tab.prevent
                >
                <ul
                    v-show="filteredOptions.length > 0"
                    ref="options"
                    class="search-select-options"
                >
                    <li
                        v-for="(option, i) in filteredOptions"
                        :key="i"
                        class="search-select-option"
                        :class="{ 'is-active': i === highlightedIndex}"
                        @click="select(option)"
                    >
                        {{ option }}
                    </li>
                </ul>
                <div v-show="filteredOptions.length === 0" class="p-sm text-neutral-dark">
                    Inga resultat på "{{ search }}"
                </div>
            </div>
        </div>
    </on-click-outside>
</template>

<script>
    import OnClickOutside from '../OnClickOutside';
    import Popper from 'popper.js';

    export default {
        components: {
            OnClickOutside,
        },
        props: {
            value: {
                type: String,
                default: null,
            },
            options: {
                type: Array,
                required: true,
            },
            filterFunction: {
                type: Function,
                default: null,
            },
            placeholder: {
                type: String,
                required: true,
            },
        },

        data() {
            return {
                isOpen: false,
                search: '',
                highlightedIndex: 0,
            };
        },
        computed: {
            filteredOptions() {
                if (this.filterFunction) {
                    return this.filterFunction(this.search, this.options);
                }

                return this.options.filter(
                    option => option
                        .toLowerCase()
                        .includes(this.search.toLowerCase()),
                );
            },
        },
        beforeDestroy() {
            if (this.popper) {
                this.popper.destroy();
            }
        },
        methods: {
            open() {
                if (this.isOpen) {
                    return;
                }

                this.isOpen = true;
                this.$nextTick(() => {
                    this.setupPopper();
                    this.$refs.search.focus();
                    this.scrollToHighlighted();
                });
            },
            setupPopper() {
                if (this.popper === undefined) {
                    this.popper = new Popper(this.$refs.button, this.$refs.dropdown, {
                        placement: 'bottom',
                    });
                } else {
                    this.popper.scheduleUpdate();
                }
            },
            close() {
                if (! this.isOpen) {
                    return;
                }

                this.isOpen = false;
                this.$refs.button.focus();
            },
            select(option) {
                this.$emit('input', option);
                this.search = '';
                this.highlightedIndex = 0;
                this.close();
            },
            selectHighlighted() {
                this.select(this.filteredOptions[this.highlightedIndex]);
            },
            scrollToHighlighted() {
                if (this.$refs.options.children.length) {
                    this.$refs.options.children[this.highlightedIndex].scrollIntoView({
                        block: 'nearest',
                    });
                }
            },
            highlight(index) {
                this.highlightedIndex = index;

                if (this.highlightedIndex < 0) {
                    this.highlightedIndex = this.filteredOptions.length - 1;
                }

                if (this.highlightedIndex > this.filteredOptions.length - 1) {
                    this.highlightedIndex = 0;
                }

                this.scrollToHighlighted();
            },
            highlightPrev() {
                this.highlight(this.highlightedIndex - 1);
            },
            highlightNext() {
                this.highlight(this.highlightedIndex + 1);
            },
        },
    };
</script>

<style scoped>

</style>